export default __webpack_public_path__ + "static/media/ckLandingPageCoverMobile.67c0dae6.jpg";